/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { UploadsControllerTriggerFileToPdfMutationResponse, UploadsControllerTriggerFileToPdfPathParams, UploadsControllerTriggerFileToPdfQueryParams, UploadsControllerTriggerFileToPdf400, UploadsControllerTriggerFileToPdf404 } from "../../models/uploadsController/UploadsControllerTriggerFileToPdf";

function getUploadsControllerTriggerFileToPdfUrl(fileId: UploadsControllerTriggerFileToPdfPathParams["fileId"]) {
  const res = { method: 'POST', url: `/api/v1/uploads/${fileId}/file-to-pdf` as const }  
  return res
}

/**
 * @description Triggers only the file-to-pdf conversion job for a Word document, skipping the full ingestion pipeline. Used for testing file conversion in the Document Intelligence Console. Use mode=inline to execute synchronously for debugging.
 * @summary Trigger file-to-PDF conversion only
 * {@link /api/v1/uploads/:fileId/file-to-pdf}
 */
export async function uploadsControllerTriggerFileToPdf(fileId: UploadsControllerTriggerFileToPdfPathParams["fileId"], params?: UploadsControllerTriggerFileToPdfQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<UploadsControllerTriggerFileToPdfMutationResponse, ResponseErrorConfig<UploadsControllerTriggerFileToPdf400 | UploadsControllerTriggerFileToPdf404>, unknown>({ method : "POST", url : getUploadsControllerTriggerFileToPdfUrl(fileId).url.toString(), params, ... requestConfig })  
  return res.data
}